module.exports = __webpack_public_path__ + "img/circuloSpore.0cdeba65.png";